import {
  GET_WALLET_BALANCES_FAILURE,
  GET_WALLET_BALANCES_STARTED,
  GET_WALLET_BALANCES_SUCCESS,
} from "redux/ActionTypes";
// --------------------------------------------------------------------------------
const initialState = {
  rType: null,
  walletBalances: [],
  error: "",
};
export const walletReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_WALLET_BALANCES_STARTED:
      return {
        ...state,
        rType: action.type,
        error: "",
      };
    case GET_WALLET_BALANCES_SUCCESS:
      return {
        ...state,
        rType: GET_WALLET_BALANCES_SUCCESS,
        walletBalances: action.payload.walletBalances,
        error: "",
      };
    case GET_WALLET_BALANCES_FAILURE:
      return {
        ...state,
        rType: action.type,
        error: action.payload,
      };
    default:
      return state;
  }
};
